import React from 'react';

import TeksPage from '../containers/teks/TeksPage';

const TeksPageApp = (props) => (
  <TeksPage {...props} />
);

export default TeksPageApp
